import { CheckCircleFilled } from '@ant-design/icons';
import { Button } from 'antd';
import { billingSelectors } from 'containers/App/selectors';
import { getBillRegister } from 'pages/BillingProcess/thunk';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { exportFile } from 'utils/export.api';
import { t_medical_institution } from 'types';
import { getDataExportBill, updateFile, updateItemInvoice } from '../../ListBilling/thunk';
import { Wrapper } from './styles';

type LocationState = {
  medicalDetail: t_medical_institution;
};

const BillingSixStep: FC = () => {
  const [exporting, setExporting] = useState<boolean>(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation<LocationState>();
  const { itemExport, itemInvoice } = useSelector(billingSelectors);

  useEffect(() => {
    dispatch(
      getBillRegister({
        facility_id: location.state.medicalDetail.i_id || '',
        invoice_month: itemInvoice?.invoice_month || '',
      }),
    );
  }, [dispatch, itemInvoice?.invoice_month, location.state.medicalDetail.i_id]);

  const pushDetail = () => {
    history.push('/billings/detail', { bill: itemExport });
  };

  const exportBill = async () => {
    try {
      setExporting(true);
      const dataBill: any = await dispatch(
        getDataExportBill({
          i_id: itemExport?.i_id,
          facility_id: location.state.medicalDetail.i_id,
          invoice_month: itemInvoice?.invoice_month,
          invoice_id: itemExport?.invoice_id,
        }),
      );
      const file = await exportFile(
        dataBill.payload.responseBill,
        'xlsx',
        'BillHexabase',
        `${itemExport?.lookup_items.facility_id.facility_code || ''}_請求書_${
          itemExport?.lookup_items.facility_id.facility_name
        }_${itemExport?.invoice_month}`,
      );
      if (file !== 'error') {
        const resultAction: any = await dispatch(
          updateFile({
            i_id: itemExport?.i_id,
            file,
            filename: `${itemExport?.lookup_items.facility_id.facility_code || ''}_請求書_${
              itemExport?.lookup_items.facility_id.facility_name
            }_${itemExport?.invoice_month}.xlsx`,
          }),
        );
        if (updateFile.fulfilled.match(resultAction)) {
          await dispatch(
            updateItemInvoice({
              i_id: itemExport?.i_id,
              data: {
                changes: [{ id: 'file_invoice', value: [resultAction.payload.file_id] }],
                use_display_id: true,
                is_force_update: true,
              },
            }),
          );
        }
      }
      if (dataBill.payload.hospitalBills) {
        setTimeout(() => {
          exportFile(
            dataBill.payload.hospitalBills,
            'xlsx',
            'DetailCPAP',
            `${itemExport?.lookup_items.facility_id.facility_code || ''}_ご使用明細書_${
              itemExport?.lookup_items.facility_id.facility_name
            }_${itemExport?.invoice_month}`,
          );
        }, 1000);
      }

      if (dataBill.payload.psgBills) {
        setTimeout(() => {
          exportFile(
            dataBill.payload.psgBills,
            'xlsx',
            'DetailPSG',
            `${itemExport?.lookup_items.facility_id.facility_code || ''}_PSG検査明細_${
              itemExport?.lookup_items.facility_id.facility_name
            }_${itemExport?.invoice_month}`,
          );
        }, 2000);
      }

      if (dataBill.payload.inspectionBills) {
        setTimeout(() => {
          exportFile(
            dataBill.payload.inspectionBills,
            'xlsx',
            'DetailInspection',
            `${itemExport?.lookup_items.facility_id.facility_code || ''}_簡易検査明細_${
              itemExport?.lookup_items.facility_id.facility_name
            }_${itemExport?.invoice_month}`,
          );
        }, 3000);
      }
    } finally {
      setExporting(false);
    }
  };

  return (
    <Wrapper>
      <div className="section">
        <div className="extraLargeFont">7. 登録完了</div>
        <div className="finish">
          <CheckCircleFilled />
          <p className="finish-bill-text extraLargeFont">請求処理が完了しました。</p>
        </div>
        <div className="finish-step">
          <Button onClick={exportBill} className="btn-fn-step btn-down-pdf extraLargeFont" loading={exporting}>
            請求書を出力する
          </Button>
          <Button onClick={pushDetail} className="btn-fn-step btn-detail-register extraLargeFont">
            登録内容を表示する
          </Button>
        </div>
      </div>
    </Wrapper>
  );
};
export default BillingSixStep;
